import { Button } from "@/components/ui/base/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface CursorPaginationProps {
  hasPrev: boolean;
  hasNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  /** Optional label, e.g. "Showing 50". No totals — totals require a scan. */
  label?: string;
  loading?: boolean;
}

export function CursorPagination({
  hasPrev,
  hasNext,
  onPrev,
  onNext,
  label,
  loading,
}: CursorPaginationProps) {
  return (
    <div className="flex items-center justify-between px-4 py-3">
      <div className="text-muted-foreground text-sm">{label ?? ""}</div>
      <div className="flex items-center gap-1">
        <Button
          variant="outline"
          size="icon"
          className="h-8 w-8"
          onClick={onPrev}
          disabled={!hasPrev || loading}
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <Button
          variant="outline"
          size="icon"
          className="h-8 w-8"
          onClick={onNext}
          disabled={!hasNext || loading}
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
